import PropTypes from 'prop-types';
import React from 'react';

import {scaleLinear, scaleUtc, scalePoint} from 'd3-scale';
import memoize from 'lib/memoize';

import {timeToSpan} from '../lib/TimeUtils';

import {FlexLayerGroup} from "./Canvas.jsx";

import {XAxis, YAxis, ValueLines} from './Axis.jsx';


let getValues = memoize((_, data, stack) => stack ? data.collapse("group").values("y") : data.values("y"));

export default (MainContent, opts = {ordinalScale: scalePoint, defaultStack: true}) => {
    return class XYChart extends React.PureComponent {
        static displayName = 'XYChart';

        static get options() {
            return {
                stack: opts.defaultStack
            };
        }

        static get configOptions() {

            const GRANULARITIES = [
                "auto",
                "hour",
                "day",
                "month",
                "quarter",
                "year"
            ];

            return [
                [
                    {
                        name: "xKey",
                        type: "keys",
                        label: "\u2194 horizontal key",
                        filter: types => ["time", "string"].some(type => types.includes(type) && !types.includes("number"))},
                    {
                        name: "granularity",
                        type: "select",
                        values: GRANULARITIES.slice(),
                        condition: ({xKey}, keys) => xKey && keys[xKey] && keys[xKey].includes("time"),
                        defaultValue: "auto"
                    }
                ],

                {name: "yKey", type: "keys", label: "\u2195 value key", filter: types => types.includes("number")},

                [
                    {name: "groupBy", type: "keys"},
                    {type: "checkbox", name: "stack", condition: conf => conf.groupBy}
                ]
            ];
        }

        static propTypes = {
            estimatedWidth: PropTypes.number,
            names: PropTypes.array,
            groups: PropTypes.array,
            nameScale: PropTypes.string,
            data: PropTypes.object,
            hoveredItem: PropTypes.object,
            colors: PropTypes.object.isRequired,
            stack: PropTypes.bool.isRequired
        };

        static defaultProps = {
            names: [],
            stack: opts.defaultStack
        };

        render() {
            let {names, nameScale, colors, data, stack, groups, estimatedWidth, hoveredItem} = this.props;

            let values = getValues(this, data, stack);

            //todo: non-timescale = scaleOrdinal / scaleLinear
            let xScale;
            if (nameScale == "time") {
                xScale = scaleUtc()
                    .domain([
                        timeToSpan(names[0]).start,
                        timeToSpan(names[names.length - 1]).end
                    ]);
                // .rangeBands([0, size.width], 0.2);
            } else if (nameScale == "numeric") {
                xScale = scaleLinear()
                    .domain([names[0], names[names.length - 1]]);
            } else {
                xScale = (opts.ordinalScale ? opts.ordinalScale : scalePoint)()
                    .domain(names.length === 0 ? [undefined] : names);
            }

            // xScale.range([0.05, 0.95]);

            let yScale = scaleLinear()
                .domain([0, Math.max.apply(Math.max, values) * 1.10])
                .range([1, 0.05])
                .nice();

            let xkey = data.keys("x").join(",") || "";
            let ykey = data.keys("y").join(",") || "";

            let YAxisWidth = YAxis.estimateWidth(yScale);

            return (
                <FlexLayerGroup style={{flex: 1, alignSelf: "stretch", paddingRight: 20}}>
                    <FlexLayerGroup style={{flexDirection: "row", alignSelf: "stretch", alignItems: "stretch"}}>
                        <YAxis name={ykey}
                               scale={yScale}
                        />
                        <ValueLines scale={yScale}
                                    style={{
                                        flex: 1,
                                        position: "absolute",
                                        left: YAxisWidth,
                                        right: 0,
                                        bottom: 0,
                                        top: 0
                                    }}
                        />
                        <MainContent
                            {...this.props}
                            yScale={yScale}
                            xScale={xScale}
                            colors={colors}
                            data={data}
                            groups={groups}
                            type={nameScale}
                            hoveredItem={hoveredItem}
                        />
                    </FlexLayerGroup>
                    <XAxis name={xkey}
                           type={nameScale}
                           scale={xScale}
                           leftMargin={YAxisWidth}
                           rightMargin={50}
                           estimatedWidth={estimatedWidth - YAxisWidth - 50}
                           style={{marginRight: -50}}
                           values={names}
                    />
                </FlexLayerGroup>
            );
        }
    };
};



// WEBPACK FOOTER //
// ./src/kpi/charts/XYChart.jsx